// Excel and Sheets execute a cell whose first character is =, +, - or @, and device names
// and serials here are authored by an MDM administrator. Prefixing with an apostrophe
// neutralises that without losing the value, which stripping would.
const RISKY_FIRST_CHAR = /^[=+\-@\t\r]/;

const cell = (value) => {
  if (value === null || value === undefined) return '';
  let text = String(value);
  if (RISKY_FIRST_CHAR.test(text)) text = `'${text}`;
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export function toCsv(columns, rows) {
  return [
    columns.map(column => cell(column.title)),
    ...rows.map(row => columns.map(column => cell(column.value(row)))),
  ]
    .map(line => line.join(','))
    .join('\r\n');
}

// Dates, not timestamps: the export is read in a spreadsheet, and ISO `YYYY-MM-DD` is
// unambiguous, sorts as plain text, and is recognised as a date by Excel and Sheets — a
// locale rendering reads as day-first or month-first depending on who opens it. UTC, to
// match the window that counted the seat. An unparseable value is passed through rather
// than blanked, so a billing export cannot silently lose a date.
const utcDate = (value) => {
  // Absent, not falsy: `0` is a valid epoch timestamp, and this is an exported helper a
  // future caller could hand one to.
  if (value == null || value === '') return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toISOString().slice(0, 10);
};

// Shared, so the customer export and the staff export cannot drift into reporting
// different columns for the same seats.
export const SEAT_CSV_COLUMNS = [
  { title: 'Device Name', value: row => row.device_name },
  { title: 'Serial Number', value: row => row.device_serial },
  { title: 'Model', value: row => row.device_model },
  { title: 'App Version', value: row => row.app_version },
  { title: 'First Seen', value: row => utcDate(row.first_seen) },
  { title: 'Last Active', value: row => utcDate(row.last_seen) },
];

export function downloadCsv(filename, columns, rows) {
  const blob = new Blob([toCsv(columns, rows)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
